import React, { useState, useEffect } from "react"
import Navbar from "../components/Navbar"
import News from "../components/News"
import Footer from "../components/Footer"
import Remove from "@mui/icons-material/Remove"
import Add from "@mui/icons-material/Add"
import { useLocation } from "react-router-dom"
import { serverAPI } from "../services/apiParams"
import {
  Container,
  Wrapper,
  ImgContainer,
  Image,
  InfoContainer,
  Title,
  Description,
  Price,
  AddContainer,
  AmountContainer,
  Amount,
  AmountButton,
  Button,
} from "../styles/ProductPageStyle"
import { useDispatch } from "react-redux"
import { addProduct } from "../redux/cartRedux"

const Product = () => {
  const location = useLocation()
  const product_id = location.pathname.split("/")[2]
  const [product, setProduct] = useState({})
  const [quantity, setQuantity] = useState(1)
  const dispatch = useDispatch()

  useEffect(() => {
    const getProduct = async () => {
      try {
        const res = await serverAPI.get(`api/products/${product_id}`)
        setProduct(res.data.product)
      } catch (error) {
        console.log(error.response)
      }
    }
    getProduct()
  }, [product_id])

  const handleQuantity = (operation) => {
    if (operation === "decrement") {
      if (quantity > 1) {
        setQuantity((prev) => prev - 1)
      }
    } else {
      setQuantity((prev) => prev + 1)
    }
  }

  const addCart = () => {
    product.id &&
      dispatch(addProduct({ ...product, quantity, price: product.price }))
  }

  return (
    <Container>
      <News />
      <Navbar />
      <Wrapper>
        <ImgContainer>
          <Image src={product.image}></Image>
        </ImgContainer>
        <InfoContainer>
          <Title>{product.title}</Title>
          <Description>{product.description}</Description>
          <Price>$ {product.price}</Price>
          <AddContainer>
            <AmountContainer>
              <AmountButton>
                <Remove onClick={() => handleQuantity("decrement")} />
              </AmountButton>
              <Amount> {quantity} </Amount>
              <AmountButton>
                <Add onClick={() => handleQuantity("increment")} />
              </AmountButton>
            </AmountContainer>
            <Button onClick={addCart}>ADD TO CART</Button>
          </AddContainer>
        </InfoContainer>
      </Wrapper>
      <Footer />
    </Container>
  )
}

export default Product
